import { jsx } from "panel";
import { FullWidthReportEl } from "common/widgets/fullwidth-report";
import { DownloadWrapperEl } from "common/components/download-wrapper";
import { UpsellModalEl } from "common/widgets/upsell-modal";
import { LoadingResource, ReportEditorActivePanel } from "common/report-editor/types";
import { ToggleEl } from "common/components/toggle";
import { ChartCustomizationPanelEl } from "common/query-builder/chart-customization/panel";
import { QueryReason } from "common/report/util/query-tracking/types";
import { ToggleTheme } from "common/components/toggle/types";
import { ChartRootEl } from "common/charts/root";
export function template() {
  var _a, _b, _c, _d, _e, _f;
  const ReportQueryBuilderEl = (_a = this.state.reportManager) == null ? void 0 : _a.queryBuilderEl;
  const ReportVisualizationEl = (_b = this.state.reportManager) == null ? void 0 : _b.visualizationEl;
  const ReportHeaderEl = (_c = this.state.reportManager) == null ? void 0 : _c.reportHeaderEl;
  const visualizationEl = ReportVisualizationEl && /* @__PURE__ */ jsx(
    ReportVisualizationEl,
    {
      attrs: { ...this.visualizationAttrs(), elref: `reportVisualization` },
      props: this.visualizationProps(),
      hook: { insert: this.helpers.vizInserted },
      on: this.visualizationEventHandlers
    }
  );
  if (this.isDownloadMode()) {
    return ReportVisualizationEl && /* @__PURE__ */ jsx(
      ChartRootEl,
      {
        params: {
          bookmarkParams: (_d = this.state.editedBookmark) == null ? void 0 : _d.params
        }
      },
      /* @__PURE__ */ jsx(
        DownloadWrapperEl,
        {
          sel: ".download-wrapper-el",
          class: {
            "inherit-size": true
          },
          attrs: { meta: this.getReportMeta(), mode: this.getDownloadMode(), elref: `downloadWrapper` }
        },
        visualizationEl
      )
    );
  }
  const upsell = (_e = this.state.reportManager) == null ? void 0 : _e.getReportUpsell(this.currentProjectContext);
  const isQueryBuilderReady = ReportQueryBuilderEl && this.state.renderStage >= 3 && !this.state.loading[LoadingResource.ApiResources];
  return /* @__PURE__ */ jsx(
    "div",
    {
      sel: ".mp-report-editor",
      class: {
        "inherit-size": true
      }
    },
    /* @__PURE__ */ jsx(
      ChartRootEl,
      {
        params: {
          bookmarkParams: (_f = this.state.editedBookmark) == null ? void 0 : _f.params,
          onBookmarkUpdate: ({ params, requery }) => this.handleBookmarkUpdate({ params, requery })
        }
      },
      /* @__PURE__ */ jsx(
        FullWidthReportEl,
        {
          sel: ".fullwidth-report-el",
          class: {
            "inherit-size": true
          },
          params: {
            reportSamplingFactor: this.state.reportSamplingFactor,
            reportHeader: ReportHeaderEl && this.state.renderStage >= 1 ? /* @__PURE__ */ jsx(
              ReportHeaderEl,
              {
                attrs: { elref: `reportHeader` },
                params: this.reportHeaderParams(),
                props: this.reportHeaderProps(),
                on: this.reportHeaderEventHandlers,
                hook: { insert: this.helpers.headerInserted }
              }
            ) : /* @__PURE__ */ jsx("div", { sel: ".report-header-loading" }, /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-header" })),
            panelHeader: isQueryBuilderReady && this.canUseChartCustomization() && /* @__PURE__ */ jsx("div", { sel: ".query-panel-toggle" }, /* @__PURE__ */ jsx(
              ToggleEl,
              {
                attrs: {
                  elref: `queryPanelToggle`,
                  theme: ToggleTheme.TabBarBorderless,
                  selected: this.state.activePanel
                },
                params: {
                  options: [
                    {
                      label: ({ t }) => t(`query-builder.report-query-tab`),
                      value: ReportEditorActivePanel.QueryBuilder
                    },
                    {
                      label: ({ t }) => t(`query-builder.chart-customization-tab`),
                      value: ReportEditorActivePanel.ChartCustomization
                    }
                  ]
                },
                on: {
                  select: (ev) => this.update({ activePanel: ev.detail.selected })
                }
              }
            )),
            queryBuilder: isQueryBuilderReady ? /* @__PURE__ */ jsx("div", null, this.state.activePanel === ReportEditorActivePanel.QueryBuilder ? /* @__PURE__ */ jsx(
              ReportQueryBuilderEl,
              {
                params: this.queryBuilderParams(),
                on: this.queryBuilderEventHandlers,
                hook: { insert: this.helpers.qbInserted }
              }
            ) : /* @__PURE__ */ jsx(
              ChartCustomizationPanelEl,
              {
                bookmarkType: this.state.editedBookmark.type,
                bookmarkParams: this.state.editedBookmark.params,
                onUpdate: (updateType, update, diff, old) => this.handleChartCustomizationUpdate(updateType, update, diff, old),
                onUpdateTheme: (params) => {
                  this.handleBookmarkUpdate({
                    params,
                    queryReason: QueryReason.QbOtherUpdate,
                    requery: false,
                    hasChangedChartType: false
                  });
                }
              }
            )) : /* @__PURE__ */ jsx("div", { sel: ".qb-loading", attrs: { elref: `loadingQB` } }, /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-header" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" })),
            report: ReportVisualizationEl && this.state.renderStage >= 2 && !this.state.loading[LoadingResource.ApiResources] && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".results", attrs: { slot: `report` } }, visualizationEl))
          }
        }
      )
    ),
    upsell && /* @__PURE__ */ jsx(UpsellModalEl, { attrs: { ...upsell.attrs, elref: `upsellModal` }, props: upsell.props })
  );
}
